import { render, staticRenderFns } from "./PlatesSubstitution.vue?vue&type=template&id=bbce9b5c&scoped=true"
import script from "./PlatesSubstitution.vue?vue&type=script&lang=js"
export * from "./PlatesSubstitution.vue?vue&type=script&lang=js"
import style0 from "./PlatesSubstitution.vue?vue&type=style&index=0&id=bbce9b5c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbce9b5c",
  null
  
)

export default component.exports